import { Exporter } from 'dashboard/models/exporter';
import { User } from 'dashboard/models/user';
import Action from 'lib/interfaces/Action';
import { PaginationParams } from 'lib/interfaces/api';

interface ExportersPayload {
  exporters: Exporter[];
  paginationParams: PaginationParams;
}

interface CurrentPagePayload {
  currentPage: number;
}

interface PageSizePayload {
  pageSize: number;
}

interface ExportersDetailsPayload {
  users: User[];
}

export type ExportersActions =
  | Action<ExportersActionType.SaveExporters, ExportersPayload>
  | Action<ExportersActionType.SaveCurrentPage, CurrentPagePayload>
  | Action<ExportersActionType.SavePageSize, PageSizePayload>
  | Action<ExportersActionType.SetExporterDetails, ExportersDetailsPayload>;

export enum ExportersActionType {
  SaveExporters = 'exporters/SAVE_EXPORTERS',
  SaveCurrentPage = 'exporters/SAVE_CURRENT_PAGE',
  SavePageSize = 'exporters/SAVE_PAGE_SIZE',
  SetExporterDetails = 'exporters/SAVE_EXPORTER_DETAILS',
}

export function saveExporters(exporters: Exporter[], paginationParams: PaginationParams) {
  return {
    payload: {
      exporters,
      paginationParams,
    },
    type: ExportersActionType.SaveExporters,
  };
}

export function saveCurrentPage(currentPage: number) {
  return {
    payload: {
      currentPage,
    },
    type: ExportersActionType.SaveCurrentPage,
  };
}

export function savePageSize(pageSize: number) {
  return {
    payload: {
      pageSize,
    },
    type: ExportersActionType.SavePageSize,
  };
}

export function setExporterDetails(users: User[]) {
  return {
    payload: {
      users,
    },
    type: ExportersActionType.SetExporterDetails,
  };
}
